<template>
  <div>
    <v-layout wrap :style="{ margin: '-0.25rem' }">
      <v-flex xs12 sm6 class="pa-1">
        <label for="from" class="d-block caption">{{ $t('from') }}</label>
        <DatepickerCustomDialog
          :value="filter.from"
          @input="$emit('update:filter', { ...filter, from: $event })"
        >
          <template #default="{ computedDate }">
            <v-text-field
              id="from"
              :value="computedDate"
              readonly
              outline
              single-line
              hide-details
            />
          </template>
        </DatepickerCustomDialog>
      </v-flex>
      <v-flex xs12 sm6 class="pa-1">
        <label for="to" class="d-block caption">{{ $t('to') }}</label>
        <DatepickerCustomDialog
          :value="filter.to"
          @input="$emit('update:filter', { ...filter, to: $event })"
        >
          <template #default="{ computedDate }">
            <v-text-field id="to" :value="computedDate" readonly outline single-line hide-details />
          </template>
        </DatepickerCustomDialog>
      </v-flex>
    </v-layout>
    <!-- <div :style="{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap', gap: '0.5rem' }">
      <v-chip class="ma-0">{{ $t('track_count') }}: 0</v-chip>
      <v-chip class="ma-0">{{ $t('clicked_user_count') }}: 0</v-chip>
    </div> -->
    <v-data-table
      :headers="headers"
      :items="result.items"
      :total-items="result.total"
      :pagination="filter.pagination"
      :rows-per-page-items="[10, 25, 50]"
      :loading="loading"
      class="mt-2 elevation-1"
      @update:pagination="$emit('update:filter', { ...filter, pagination: $event })"
    >
      <template #items="{ item }">
        <td>{{ item.user_id || '-' }}</td>
        <td>
          {{
            item.user_social_name ||
            [item.user.first_name, item.user.last_name].join(' ').trim() ||
            '-'
          }}
        </td>
        <td>{{ item.user_group_id || '-' }}</td>
        <td>
          {{ getGroupName(item.user_group_id) || item.user_group_id || '-' }}
        </td>
        <td>{{ item.channel || '-' }}</td>
        <td>{{ item.value || '-' }}</td>
        <td>{{ item.tracking_url || '-' }}</td>
        <td>{{ item.created_at | DateFormat('DD/MM/YYYY HH:mm') }}</td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog'
import eventTrackingApi from '@/api/event-tracking'
import { mapGetters } from 'vuex'
import lineBotGroupApi from '@/api/line-bot-group'

export default {
  components: {
    DatepickerCustomDialog
  },
  props: {
    broadcastId: {
      type: Number,
      required: true
    },
    trackingUrlIds: {
      type: Array,
      required: true
    },
    filter: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      result: {
        items: [],
        total: 0
      },
      loading: false,
      lineGroups: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    headers() {
      return [
        {
          text: 'User ID',
          value: 'userId',
          sortable: false
        },
        {
          text: 'Social name',
          value: 'socialName',
          sortable: false
        },
        {
          text: 'Group ID',
          value: 'groupId',
          sortable: false
        },
        {
          text: 'Group name',
          value: 'groupName',
          sortable: false
        },
        {
          text: 'Event channel',
          value: 'eventChannel',
          sortable: false
        },
        {
          text: 'Event value',
          value: 'eventValue',
          sortable: false
        },
        {
          text: 'URL',
          value: 'url',
          sortable: false
        },
        {
          text: 'Timestamp',
          value: 'timestamp',
          sortable: false
        }
      ]
    }
  },
  watch: {
    filter: {
      immediate: true,
      handler() {
        this.fetch()
      }
    }
  },
  created() {
    this.fetchLineGroups()
  },
  methods: {
    async fetch() {
      try {
        this.loading = true
        const response = await eventTrackingApi.getLonAnalyticsDetail(this.selectedBot.pageid, {
          tracking_url_ids: this.trackingUrlIds,
          lon_broadcast_id: this.broadcastId,
          limit: this.filter.pagination.rowsPerPage,
          offset: (this.filter.pagination.page - 1) * this.filter.pagination.rowsPerPage,
          date_from: dayjs(this.filter.from).startOf('day').valueOf(),
          date_to: dayjs(this.filter.to).endOf('day').valueOf()
        })
        const { data, total } = response.data
        this.result = {
          items: data,
          total: total
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async fetchLineGroups() {
      try {
        const response = await lineBotGroupApi.getLiveChatGroups({
          pageId: this.selectedBot.pageid,
          params: {
            limit: 1000,
            offset: 0
          }
        })
        const { data } = response.data
        this.lineGroups = data
      } catch (error) {
        console.error(error)
      }
    },
    getGroupName(groupId) {
      const group = this.lineGroups.find((group) => group.group_id === groupId)
      return group ? group.group_name : undefined
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/LonBroadcast/EventTracking/index.vue